import { observer } from 'mobx-react-lite';
import React from 'react';
import { Payment } from '../api/types';
import TransactionItem from './transactions/TransactionItem';

interface Props {
  payments: Payment[];
  isLoading: boolean;
  hasMore: boolean;
  onLoadMore: () => void;
  workspaceSlug: string;
  isAdmin: boolean;
  emptyTitle: string;
  loadingText: string;
  loadMoreText: string;
}

const TransactionList: React.FC<Props> = observer((props) => {
  const {
    payments,
    isLoading,
    hasMore,
    onLoadMore,
    workspaceSlug,
    isAdmin,
    emptyTitle,
    loadingText,
    loadMoreText,
  } = props;

  if (isLoading && payments.length === 0) {
    return (
      <div className="text-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">{loadingText}</p>
      </div>
    );
  }

  if (payments.length === 0) {
    return (
      <div className="text-center py-8">
        <span className="text-4xl mb-4 block">📊</span>
        <p className="text-gray-600">{emptyTitle}</p>
      </div>
    );
  }

  return (
    <>
      <div className="space-y-4">
        {payments.map((p, i) => (
          <TransactionItem
            key={`${p.createdAt}-${i}`}
            payment={p}
            workspaceSlug={workspaceSlug}
            isAdmin={isAdmin}
          />
        ))}
      </div>
      {hasMore && (
        <div className="text-center pt-4">
          <button
            onClick={onLoadMore}
            disabled={isLoading}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            {isLoading ? loadingText : loadMoreText}
          </button>
        </div>
      )}
    </>
  );
});

export default TransactionList;
